import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
    createFeatureSelector,
    createReducer,
    createSelector,
    on
} from '@ngrx/store';
import { IDirectReportsWithTimeStatus } from '../IDirectReportsWithTimeStatus';
import * as DirectReportsWithTimeStatusActions from './direct-reports-with-time-status.actions';

export const directReportsWithTimeStatusesFeatureKey =
    'directReportsWithTimeStatuses';

export interface State extends EntityState<IDirectReportsWithTimeStatus> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IDirectReportsWithTimeStatus> =
    createEntityAdapter<IDirectReportsWithTimeStatus>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const directReportsWithTimeStatusReducer = createReducer(
    initialState,
    on(
        DirectReportsWithTimeStatusActions.addDirectReportsWithTimeStatus,
        (state, action) =>
            adapter.addOne(action.directReportsWithTimeStatus, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.upsertDirectReportsWithTimeStatus,
        (state, action) =>
            adapter.upsertOne(action.directReportsWithTimeStatus, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.addDirectReportsWithTimeStatuss,
        (state, action) =>
            adapter.addMany(action.directReportsWithTimeStatuss, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.upsertDirectReportsWithTimeStatuss,
        (state, action) =>
            adapter.upsertMany(action.directReportsWithTimeStatuss, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.updateDirectReportsWithTimeStatus,
        (state, action) =>
            adapter.updateOne(action.directReportsWithTimeStatus, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.updateDirectReportsWithTimeStatuss,
        (state, action) =>
            adapter.updateMany(action.directReportsWithTimeStatuss, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.deleteDirectReportsWithTimeStatus,
        (state, action) => adapter.removeOne(action.id, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.deleteDirectReportsWithTimeStatuss,
        (state, action) => adapter.removeMany(action.ids, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.loadDirectReportsWithTimeStatuss,
        (state, action) =>
            adapter.setAll(action.directReportsWithTimeStatuss, state)
    ),
    on(
        DirectReportsWithTimeStatusActions.clearDirectReportsWithTimeStatuss,
        state => adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return directReportsWithTimeStatusReducer(state, action);
}

const localState = createFeatureSelector<State>(
    directReportsWithTimeStatusesFeatureKey
);
export const getEntities = createSelector(localState, x => x.entities);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
